import moment from "moment"
import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom/cjs/react-router-dom"

import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min"
import callAPI from "../../helpers/callAPI"
import useDateRangeFilter from "../../hooks/useDateRangeFilter"
import Dollars from "../../templates/Dollars/Dollars"
import ReportTable from '../../templates/ReportTable/ReportTable'
import Loading from "../../templates/UI/Loading/Loading"
import DateRangeFilter from "../Reports/Filters/DateRangeFilter/DateRangeFilter"

const ApiLeadsReport = ({ showSystemMessage, mode }) => {

    const history = useHistory()
    const location = useLocation()
    const [dataLoaded, setDataLoaded] = useState(false)
    const [report, setReport] = useState([])
    // const { dataLoaded, data, refetch } = useCallApi(`reports/apiLeads`, 'GET', {}, [])

    const { initStartDate, initEndDate, selectedStartDate, selectedEndDate, quickDate, handleChangeStart, handleChangeEnd, handleQuickDate } = useDateRangeFilter()

    let pageTitle = `API Leads Report ${mode === 'testing' ? '(Testing)' : ''}`
    document.title = pageTitle

    useEffect(() => {
        getReport()
    }, [location])

    const getReport = () => {
        setDataLoaded(false)

        let url = `reports/apiLeads?startDate=${initStartDate}&endDate=${initEndDate}&mode=${mode}`

        callAPI(url, 'GET')
            .then((result) => {
                if (result['success'] === true) {
                    setReport(result.data)
                    setDataLoaded(true)
                } else if (result['success'] === false) {
                    showSystemMessage('error', result.errors.message)
                    setDataLoaded(true)
                }
            })
            .catch((error) => {
                console.log(`Error while fetching API leads: ${error}`)
                showSystemMessage('error', 'An error occurred while fetching API leads')
            })
    }

    const refreshReport = (e) => {
        e.preventDefault()

        let url = `/apiLeadsReport${mode === 'testing' ? 'Testing' : ''}?startDate=${selectedStartDate}&endDate=${selectedEndDate}`

        history.push(url)
    }

    const getReportOutput = () => {
        let columns = [
            {
                Header: 'Lead ID',
                accessor: 'id',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            },
            {
                Header: 'MB offer Id',
                accessor: 'mb_offer_id',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            },
            {
                Header: 'API Offer Id',
                accessor: 'api_offer_id',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            },
            {
                Header: 'Affiliate Id',
                accessor: 'affiliate_id',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            },
            {
                Header: 'Click ID',
                accessor: 'click_action_id',
                Cell: ({ cell: { value } }) => {
                    return <>{value > 0 ? <Link to={`/searchId?actionId=${value}`}>{value}</Link> : value}</>
                },
            },
            {
                Header: 'Lead Source',
                accessor: 'lead_source',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            },
            {
                Header: 'Lead Data',
                accessor: 'lead_data',
                Cell: ({ cell: { value } }) => {
                    return <>{value ? <Link to={`/searchId?leadData=${value}`}>{value}</Link> : value}</>
                },
            },
            {
                Header: 'Rate Name',
                accessor: 'ratename',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            },
            {
                Header: () => <div style={{ textAlign: 'right' }}>Net Rate</div>,
                accessor: 'net_rate',
                className: 'text-right',
                Cell: ({ cell: { value } }) => {
                    return <Dollars value={value} />
                },
            },
            {
                Header: () => <div style={{ textAlign: 'right' }}>Sale</div>,
                accessor: 'sale_amount',
                className: 'text-right',
                Cell: ({ cell: { value } }) => {
                    return <Dollars value={value} />
                },
            },
            {
                Header: 'Transaction Date',
                accessor: 'transaction_date',
                Cell: ({ cell: { value } }) => {
                    return <>{moment(value).utc().format('YYYY-MM-DD HH:mm:ss')}</>
                },
            },
            {
                Header: 'Pull Date',
                accessor: 'pull_date',
                Cell: ({ cell: { value } }) => {
                    return <>{moment(value).utc().format('YYYY-MM-DD HH:mm:ss')}</>
                },
            },
            {
                Header: 'Processed',
                accessor: 'process',
                Cell: ({ cell: { value } }) => {
                    return <>{value === 'N' ? 'Processed' : value === 'X' ? 'Processed with errors' : 'Pending'}</>
                },
            },
            {
                Header: 'Notes',
                accessor: 'notes',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            }
        ]

        return (
            <React.Fragment>
                <ReportTable
                    data={report}
                    columns={columns}
                />
            </React.Fragment>
        )
    }

    return (
        <div>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Reports</h1>
            </div>
            <div className="card">
                <div className="card-body p-0">
                    <div className="d-flex justify-content-between p-3">
                        <div className="d-flex">
                            <div className="mr-4 d-flex allgn-items-center">
                                <div className="mr-4 d-flex align-items-center">
                                    <h1 className="mb-h1-dark">{pageTitle}</h1>
                                </div>
                                <React.Fragment>
                                    <DateRangeFilter quickDate={quickDate} selectedStartDate={selectedStartDate} selectedEndDate={selectedEndDate} handleChangeStart={handleChangeStart} handleChangeEnd={handleChangeEnd} handleQuickDate={handleQuickDate} />
                                    <div>
                                        <button onClick={refreshReport} className="btn btn-sm btn-primary">
                                            Refresh Report
                                        </button>
                                    </div>
                                </React.Fragment>
                            </div>
                        </div>
                    </div>
                    {dataLoaded ? report.length === 0 ? <div className="p-3">No stats for the current parameters.</div> : getReportOutput() : <Loading></Loading>}
                </div>
            </div>
        </div>
    )

}

export default ApiLeadsReport